import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';
import { getGridFilterSortStatus } from '../../../../services/allInvoiceApi';
import creditsHistoryColumnDef from './creditsHistoryColumnDef';
import { classes, Root } from './utils';
import getCreditHistoryData from '../../../../services/creditHistoryApi';

const CreditsHistory = ({ organizationId }) => {
  const [gridSettingData, setGridSettingData] = useState({});

  const getFilterSortData = async () => {
    try {
      const response = await getGridFilterSortStatus('credits-history');
      setGridSettingData(response);
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData();
  }, []);

  return (
    <Root className={classes.root}>
      <AgGrid
        TitleHeader="Credit History"
        className={classes.creditsHistoryAgGridStyle}
        columnData={creditsHistoryColumnDef}
        getRowData={getCreditHistoryData}
        gridSettingData={gridSettingData}
        gridKey="credits-history"
        functionData={organizationId}
        setGridSettingData={setGridSettingData}
      />
    </Root>
  );
};

CreditsHistory.propTypes = {
  organizationId: PropTypes.string.isRequired,
};

export default CreditsHistory;
